/**
 * CommunityTile - Tile design for Community Model section
 *
 * Uses BaseTile with full-bleed background image design.
 * Focus: Network reach and strategic partnership potential
 */
import React from 'react';
import BaseTile from './BaseTile';

function CommunityTile({
  resource,
  sectionColor,
  onClick,
  adminMode,
  onRemove,
  onMoveLeft,
  onMoveRight,
  isFirst,
  isLast,
}) {
  return (
    <BaseTile
      resource={resource}
      sectionColor={sectionColor}
      onClick={onClick}
      adminMode={adminMode}
      onRemove={onRemove}
      onMoveLeft={onMoveLeft}
      onMoveRight={onMoveRight}
      isFirst={isFirst}
      isLast={isLast}
    />
  );
}

export default CommunityTile;
